import { render, staticRenderFns } from "./InputRadioGroup.vue?vue&type=template&id=dded717a&scoped=true"
import script from "./InputRadioGroup.vue?vue&type=script&lang=js"
export * from "./InputRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./InputRadioGroup.vue?vue&type=style&index=0&id=dded717a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dded717a",
  null
  
)

export default component.exports